import React from 'react';
import WordsAndSpelling from '../words-and-spelling';
import GraphicOrganizer from '../graphic-organizer';
import Vocabulary from '../vocabulary';
import Sentence from '../sentence';
import SequenceGraphicOrganizer from '../sequence-graphic-organizer';
import StoryOrganizer from '../story-organizer';
import MyOpinion from '../my-opinion';
import CompletionCertificate from '../completion-certificate';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

/** Key is sheetId */
const Map = {
  40: {
    name: 'wordsAndSpelling',
    Component: props => <WordsAndSpelling {...props} isNarrow />
  },
  41: {
    name: 'vocabulary',
    Component: props => <Vocabulary {...props} isNarrow />
  },
  411: {
    name: 'sentence',
    Component: props => <Sentence {...props} isNarrow />
  },
  42: {
    name: 'sequenceGraphicOrganizer',
    Component: props => <SequenceGraphicOrganizer {...props} isNarrow />
  },
  43: {
    name: 'sequenceGraphicOrganizer',
    Component: props => <GraphicOrganizer {...props} isNarrow />
  },
  44: {
    name: 'storyOrganizer',
    Component: props => <StoryOrganizer {...props} isNarrow />
  },
  45: {
    name: 'myOpinion',
    Component: props => <MyOpinion {...props} isNarrow />
  },
  46: {
    name: 'wordsAndSpellingCursive',
    Component: props => <WordsAndSpelling {...props} isNarrow isCursive />
  },
  47: {
    name: 'vocabularyCursive',
    Component: props => <Vocabulary {...props} isNarrow isCursive />
  },
  471: {
    name: 'sentenceCursive',
    Component: props => <Sentence {...props} isNarrow isCursive />
  },
  48: {
    name: 'sequenceGraphicOrganizerCursive',
    Component: props => <SequenceGraphicOrganizer {...props} isCursive isNarrow />
  },
  49: {
    name: 'graphicOrganizerCursive',
    Component: props => <GraphicOrganizer {...props} isCursive isNarrow />
  },
  50: {
    name: 'storyOrganizerCursive',
    Component: props => <StoryOrganizer {...props} isCursive isNarrow />
  },
  51: {
    name: 'myOpinionCursive',
    Component: props => <MyOpinion {...props} isCursive isNarrow />
  },
  52: {
    name: 'certificateOfCompletionRabbit',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'rabbitHat',
            width: 200,
            height: 300,
            margin: '30px 0 0'
          }
        ]}
        completedTitle={t('cursiveHandwriting')}
        isCursive
      />
    )
  },
  53: {
    name: 'certificateOfCompletionBand',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'marchingBand',
            width: 700,
            height: 200,
            flipImage: true
          }
        ]}
        completedTitle={t('cursiveSuccess')}
        isCursive
      />
    )
  },
  54: {
    name: 'certificateOfCompletionPeople1',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'teacher',
            width: 100,
            height: 300,
            margin: '20px 50px 0px 50px'
          },
          {
            name: 'teachers',
            width: 310,
            height: 310,
            margin: '0px 50px 10px 0px'
          }
        ]}
        completedTitle={t('CanDoPrint')}
      />
    )
  },
  55: {
    name: 'certificateOfCompletionPeople2',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'teachers',
            width: 310,
            height: 310,
            margin: '0px 20px 0px 0px'
          },
          {
            name: 'twoTruckGuy',
            width: 200,
            height: 300,
            margin: '10px 0px 10px 0px'
          }
        ]}
        completedTitle={t('CanDoCursive')}
        width={200}
        height={100}
        isCursive
      />
    )
  }
};

export default Map;
